export const GIG_ITEM_PREFIX = 'gig_items';
export const GIG_ITEM_ID = 'gig_item_id';
export const QUANTITY = 'quantity';
